import { FilestackImageData } from 'api/types/shared.types';
import { FilestackImage } from 'components/Image';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme';

import {
  CmsTileModalLeftContentContainer,
  CmsTileModalLeftContentImageContainer,
} from './CmsTileModalLeftContent.styled';

type Props = {
  imageData: FilestackImageData;
  caption: string | undefined;
};

export function CmsTileModalLeftContent({ imageData, caption }: Props) {
  return (
    <CmsTileModalLeftContentContainer>
      <CmsTileModalLeftContentImageContainer>
        <FilestackImage
          data={imageData}
          objectFit="cover"
          expandSize
          maxWidth={1200}
          maxHeight={1200}
          aspectRatio={{ width: 1, height: 1 }}
        />
      </CmsTileModalLeftContentImageContainer>

      {caption && (
        <BodySmall color={colors.lightContentGrey} mt="8px" as="figcaption">
          {caption}
        </BodySmall>
      )}
    </CmsTileModalLeftContentContainer>
  );
}
